import { axios } from "../utils/request";
import { Log } from "../utils/debug";

export function apiSaveArticle(params) {
    Log.debug("POST: /api/article", params);
    return axios.post("/article", params);
}

export function apiGetArticles(filter) {
    Log.debug("filter", filter);
    Log.debug("GET: /api/articles");

    let queryParams = "";
    if (filter) {
        if (filter.trash) {
            queryParams += "trash=true";
        }
    }

    if (queryParams !== "") {
        queryParams = "?" + queryParams;
    }

    return axios.get("/articles" + queryParams);
}

export function apiGetArticle(IDStr) {
    Log.debug("GET: /api/article/:IDStr");
    return axios.get("/article/" + IDStr);
}

export function apiDeleteArticle(IDStr, method) {
    let url = "/article?id=" + IDStr + "&method=" + method;
    Log.debug("DELETE: /api" + url);
    return axios.delete(url);
}
